import { isAcceptedSignatureType, MAX_SIGNATURE_SIZE } from '@omecare/utils';
import { z } from 'zod';

/** `accept` attribute of the admin's signature file input: PNG and JPEG. */
export const ACCEPTED_SIGNATURE_FILE_INPUT = 'image/png,image/jpeg';

/**
 * A signature file, when one is given: a drawn PNG, or a PNG/JPEG scan
 * imported by an admin, within the API's size limit. `null`/`undefined` pass —
 * whether a signature is required depends on the form.
 */
export const optionalSignatureFileSchema = z
  .instanceof(File)
  .nullish()
  .refine((file) => !file || isAcceptedSignatureType(file.type), {
    message: 'form.errors.signature-file-type',
  })
  .refine((file) => !file || file.size <= MAX_SIGNATURE_SIZE, {
    message: 'form.errors.signature-max-size',
  });

/** A signature file that must be given (invitation signup). */
export const requiredSignatureFileSchema = z
  .instanceof(File, { message: 'form.errors.signature-required' })
  .refine((file) => isAcceptedSignatureType(file.type), {
    message: 'form.errors.signature-file-type',
  })
  .refine((file) => file.size <= MAX_SIGNATURE_SIZE, {
    message: 'form.errors.signature-max-size',
  });
